// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "0a265df0505dee6cdc32b2f06d9746fb" + ".js";
};